import type { ContactInfo, CustomerUpdateRequest } from '../../generated-types';
import { updateContactInformation } from '../../services/profileService';
import { UpdateContactInfoState } from './form/state';

export default (defaultContactInfo?: ContactInfo, enableUpdateEmail = true, enableUpdatePhone = false) =>
    (state: UpdateContactInfoState) => {
        if (!enableUpdateEmail && !enableUpdatePhone) {
            return updateContactInformation({
                email: defaultContactInfo?.email?.value,
                phonenumber: defaultContactInfo?.phoneNumber,
                deviceId: window.ReactNativeProps?.deviceId,
            });
        }
        if (enableUpdateEmail && !enableUpdatePhone) {
            return updateContactInformation({
                email: state.email,
                deviceId: window.ReactNativeProps?.deviceId,
            });
        }
        if (!enableUpdateEmail && enableUpdatePhone) {
            return updateContactInformation({
                phonenumber: { value: state.mobile ?? '' },
                deviceId: window.ReactNativeProps?.deviceId,
            });
        }
        const payload: CustomerUpdateRequest = {
            phonenumber: { value: state.mobile ?? '' },
            email: state.email,
            deviceId: window.ReactNativeProps?.deviceId,
        };
        return updateContactInformation(payload);
    };
